var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutreachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h44v44H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.38 24.16c-1.17 1.09-2.3 1.5-3.395 1.5-1.095 0-2.183-.478-2.875-1.123-.749-.698-1.437-1.86-1.437-3.061 0-1.203.511-2.049 1.102-2.6.753-.702 1.884-1.198 3.566-1.198 1.329 0 2.55.29 3.653 1.319.718.67.87 1.455.87 1.991 0 .74-.315 2.082-1.484 3.172Zm-4.287-11.709c-3.53 0-6.191.833-7.735 2.272-1.667 1.554-2.32 3.423-2.32 5.558 0 3.387 1.838 7.019 4.404 9.411.67.625 2.985 2.544 6.014 2.544 3.1 0 5.405-1.765 6.853-3.116 2.803-2.612 5.34-7.117 5.34-10.054a4.564 4.564 0 0 0-1.425-3.354c-2.435-2.27-7.668-3.26-11.13-3.26Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutreachIcon);
export default __webpack_public_path__ + "static/media/outreach-icon.c047457a471ddbc1cab3c58d2e91732d.svg";
export { ForwardRef as ReactComponent };